
export class Temp {
	static tag(name, o) {
		const el = $('<'+name+'></'+name+'>');
		if (o) {
			if (o.style != null) el.attr('style', o.style);
			if (o.id != null) el.attr('id', o.id);
			if (o.clazz != null) el.attr('class', o.clazz);
		}
		return el;
	}
	static text (o) {
		const el = Temp.tag('input', o);
		let type = "text";
		if (o) {
			if (o.name != null) el.attr('name', o.name);
			if (o.placeholder != null) el.attr('placeholder', o.placeholder);
			if (o.size != null) el.attr('size', o.size);
			if (o.maxLength != null) el.attr('maxlength', o.maxLength);
			if (o.tabindex != null) el.attr('tabindex', o.tabindex);
			if (o.value != null) el.attr('value', o.value);
			if (o.readOnly) el.attr('readonly', 'readonly');
			if (o.type) type = o.type;
		}
		el.attr('type', type);
		return el;
	};

	static checkbox(o) {
		const el = Temp.tag('input', o);
		el.attr('type', 'checkbox');
		if (o) {
			if (o.name != null) el.attr('name', o.name);
			if (o.tabindex != null) el.attr('tabindex', o.tabindex);
			if (o.value) el.prop('checked', true);
			if (o.readOnly) el.attr('disabled', 'disabled');
		}
		return el;
	};

	static textarea(o) {
		const el = Temp.tag('textarea', o);
		if (o) {
			if (o.name != null) el.attr('name', o.name);
			if (o.placeholder != null) el.attr('placeholder', o.placeholder);
			if (o.rows != null) el.attr('rows', o.rows);
			if (o.cols != null) el.attr('cols', o.cols);
			if (o.maxLength != null) el.attr('maxlength', o.maxLength);
			if (o.tabindex != null) el.attr('tabindex', o.tabindex);
			if (o.readOnly) el.attr('readonly', 'readonly');
			if (o.value != null) el.val(o.value);
		}
		return el;
	};

	static hidden(o) {
		const el = Temp.tag('input', o);
		el.attr('type', 'hidden');
		if (o) {
			if (o.name != null) el.attr('name', o.name);
			if (o.value != null) el.attr('value', o.value);
		}
		return el;
	};

	static icon(o) {
		const el = Temp.tag('img', o);
		el.addClass('icn');
		if (o != null) {
			el.attr('src', o.src == null ? 'i/info.jsp' : o.src);
			if (o.alt != null) el.attr('alt', o.alt);
		}
		return el;
	};

	static option(o) {
		const el = $('<option></option>');
		if (o) {
			if (o.name != null) el.text(o.name);
			if (o.value != null) el.attr('value', o.value);
		}
		return el;
	}

	static select(o) {
		const el = Temp.tag('select', o);
		if (o) {
			if (o.name != null) el.attr('name', o.name);
			if (o.multi != null) el.attr('multiple', 'true');
			if (o.items) {
				for (let i = 0; i < o.items.length; i++) {
					let op = Temp.option(o.items[i]);
					if (o.value && o.value == o.items[i].value) op.attr('selected', 'selected');
					el.append(op);
				}
			}
			if (o.readOnly) el.attr('disabled', 'disabled');
		}
		return el;
	};

	static suggester(o) {
		var myid = o.id || o.name;
		var pkid = myid+'_PK_';
		var div = $('<div style="display:inline"></div>');
		div.attr('id', '_'+myid+'_');
		if (o.idName) {
			// Generate field for primary key
			div.append(Temp.hidden({name: o.idName, id: pkid}));
		} else pkid = myid;
		var txt = Temp.text(o);
		txt.attr('autocomplete', 'off');
		txt.attr('id', myid);
		if (!o.readOnly) {
			txt.on('focus', function(e) {
				var sInfo = Suggester.initSuggester({
					queryId: myid,
					pkId: pkid,
					suggester: o.suggester, options: '', separator: '',
					propagator: o.propagator,
					suggEmpty: o.suggEmpty,
					suggNew: o.suggNew,
					stayFocused: o.stayFocused,
					minWidth: o.minWidth,
					addEntity: '',
					formColor: o.formColor
				});
				if (o.onnew && typeof o.onnew === 'function') sInfo.onnew = o.onnew;
			});
		}
		div.append(txt);
		var res = $('<div id="'+myid+'_results" class="results"></div>');
		div.append(res);
		return div;

	}

	static row(left, right, o) {
		var row = $('<tr></tr>');
		var labelCell = $('<td class="flabel"></td>');
		var controlCell = $('<td></td>');
		labelCell.append(left);
		controlCell.append(right);
		row.append(labelCell);
		row.append(controlCell);
		return row;
	}

	static fieldRow(label, control, o) {
		return Temp.row(document.createTextNode(label+':'), control, o);
	}
}
